<template>

  <t-page>

    <t-page-list :title="currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements"
                 @getPage="getPage">


      <template #breadcrumb>

        <b-row>
          <!--Retorno com back devido dinâmica de como página de origem é criada podendo ser custom ou não-->
          <b-breadcrumb>
            <b-breadcrumb-item @click="$router.back()">Estoque de Produto</b-breadcrumb-item>
            <b-breadcrumb-item active>{{currentPage.pageTitle}}</b-breadcrumb-item>
          </b-breadcrumb>

        </b-row>

      </template>

      <template #search>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         big-search
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-product v-model="form.productId"/>


          <b-row>

            <t-input-search cols="6" v-model="form.modelId" :options="modelOptions"
                            label="Modelo" select/>

            <t-input-search cols="6" v-model="form.groupProductId"
                            :options="groupProductOptions"
                            label="Grupo de produtos"
                            select/>

          </b-row>

          <b-row>

            <t-input-search cols="8" v-model="form.stockPlaceProductInsideId" :options="stockPlaceProductInsideOptions"
                            label="Local de Armazenamento" select/>

            <t-input-search cols="4" v-model="form.unitId"
                            :options="unitOptions"
                            label="Embalagem"
                            select/>

          </b-row>


        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               delete-by-confirm-column="stockProductInOutId"
               link-primary-column="productCodeLabel"
               primary-key-column="stockProductNumber">

        <template #first-column="{item}">
          {{ item.productCodeLabel }}
        </template>
        <template #item(stockPlaceProductInside)="{item}">
          <span v-if="item.stockOnlyNewProduced">{{ item.stockPlaceProductInside }}</span>
          <span v-else class="text-danger">{{ item.stockPlaceProductInside }}</span>
        </template>

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'StockProductInOut',
  data() {
    return {
      path: "stock/product-in-out",
      form: {
        productId: 0,
        groupProductId: 0,
        modelId: 0,
        unitId: 0,
        stockPlaceProductInsideId: 0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalStockProductId: 0,
      modalStockProductPlaceId: 0,
      modelOptions: [],
      groupProductOptions: [],
      stockPlaceProductInsideOptions: [],
      unitOptions: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {

      delete this.form.status

    },
    async mountedContinued() {

      await http.list("stock/product/selectRelationList").then((response) => {

        this.groupProductOptions = response.groupProductOptions
        this.modelOptions = response.modelOptions
        this.stockPlaceProductInsideOptions = response.stockPlaceProductInsideOptions
        this.unitOptions = response.unitOptions

      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
